import { getQuery, postQuery } from "utils/api";

// A half-finished login carries its own short-lived token. It is sent
// explicitly, and a 401 on it must not log the browser out (the interceptor
// would otherwise wipe the session and redirect with no explanation).
const withToken = (token) =>
  token
    ? { headers: { authorization: token }, skipLogoutOn401: true }
    : undefined;

export const mfaError = (err, fallback = "Something went wrong. Please try again.") => {
  if (err?.response?.status === 401) {
    return "Your sign-in has timed out. Please sign in again.";
  }
  return err?.response?.data?.message || fallback;
};

export const loginWithCode = (mfaToken, body) =>
  postQuery("tutor/login/mfa", { mfaToken, ...body });

export const mfaStatus = () => getQuery("mfa/status");
export const mfaSetupStart = (token, body = {}) =>
  postQuery("mfa/setup/start", body, withToken(token));
export const mfaSetupConfirm = (token, body) =>
  postQuery("mfa/setup/confirm", body, withToken(token));
export const mfaRecoveryCodes = (code) => postQuery("mfa/recovery-codes", { code });
export const mfaDisable = (code) => postQuery("mfa/disable", { code });
export const mfaAdmins = () => getQuery("mfa/admins");
export const mfaReset = (adminId) => postQuery("mfa/reset", { adminId });
